import { Item } from '@react-stately/collections'
import { CollectionElement } from '@react-types/shared'
import { Edit, Comment, ReadReceipt } from 'almanac-ui/icons'
import { Menu } from 'components/Menu/Menu'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import Styles from './SwitchViewMenu.module.scss'
import { SwitchViewMenuProps } from './Types'

export const SwitchViewMenu = observer(({ articleView, onAction }: SwitchViewMenuProps) => {
  const { docStore } = useRootStore()

  const isMainLayer = docStore?.isMainLayer
  const permissions = docStore?.permissions

  return (
    <Menu
      className={Styles.menu}
      selectionMode="single"
      selectedKeys={new Set([articleView])}
      aria-label="Switch view"
      showCheckmark={false}
      onAction={onAction}
      itemClassName={Styles.menuItem}
    >
      {
        [
          permissions?.can_edit && (
            <Item key="Editing" textValue="Editing">
              <div className={Styles.itemWithDescription}>
                <span className={Styles.icon}>
                  <Edit />
                </span>
                <div className={Styles.content}>
                  Editing
                  <div className={Styles.description}>Make changes directly in doc.</div>
                </div>
              </div>
            </Item>
          ),
          isMainLayer && permissions?.can_comment && (
            <Item key="Commenting" textValue="Commenting">
              <div className={Styles.itemWithDescription}>
                <span className={Styles.icon}>
                  <Comment />
                </span>
                <div className={Styles.content}>
                  Commenting
                  <div className={Styles.description}>View the doc as comment-only users would see it.</div>
                </div>
              </div>
            </Item>
          ),
          isMainLayer && permissions?.can_read && (
            <Item key="Reading" textValue="Reading">
              <div className={Styles.itemWithDescription}>
                <span className={Styles.icon}>
                  <ReadReceipt />
                </span>
                <div className={Styles.content}>
                  Reading
                  <div className={Styles.description}>View the doc as read-only users would see it.</div>
                </div>
              </div>
            </Item>
          ),
        ] as CollectionElement<HTMLElement>[]
      }
    </Menu>
  )
})
